import { startOfWeek, endOfWeek } from 'date-fns';

export function toAmsterdamTime(isoString) {
  try {
    return new Intl.DateTimeFormat('nl-NL', {
      timeZone: 'Europe/Amsterdam',
      hour: '2-digit',
      minute: '2-digit',
    }).format(new Date(isoString));
  } catch {
    return '';
  }
}

export function toAmsterdamDate(isoString) {
  try {
    return new Date(
      new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Amsterdam' }).format(new Date(isoString))
    );
  } catch {
    return new Date(isoString);
  }
}

export function weekBounds(baseDate) {
  const start = startOfWeek(baseDate, { weekStartsOn: 1 });
  const end = endOfWeek(baseDate, { weekStartsOn: 1 });
  return { start, end };
}

// Converteert een Amsterdam datum+tijd naar een ISO-string met correcte UTC-offset.
// DST-randgeval (1.2, 2026-07-10): tussen 02:00-03:00 lokale tijd bestaat een tijd
// tijdens de voorjaars-overgang niet (wordt overgeslagen) en tijdens de najaars-
// overgang twee keer (ambigu). Deze functie plakt zo'n tijd stilzwijgend op de
// nieuwe offset van die dag (bepaald via de UTC-12:00-referentie) — geen aparte
// afhandeling, bewust aanvaard: sportlessen worden nooit in dit venster gepland.
export function toAmsterdamISO(dateStr, timeStr) {
  const ref = new Date(`${dateStr}T12:00:00Z`);
  const amsHour = parseInt(
    new Intl.DateTimeFormat('nl-NL', {
      timeZone: 'Europe/Amsterdam',
      hour: '2-digit',
      hour12: false,
    }).format(ref),
    10,
  );
  const offset = (amsHour - 12) === 2 ? '+02:00' : '+01:00';
  return `${dateStr}T${timeStr}:00${offset}`;
}

export function todayStr() {
  return new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Amsterdam' }).format(new Date());
}

export function nowTimeStr() {
  const parts = new Intl.DateTimeFormat('nl-NL', {
    timeZone: 'Europe/Amsterdam', hour: '2-digit', minute: '2-digit', hour12: false,
  }).formatToParts(new Date());
  const p = Object.fromEntries(parts.map(({ type, value }) => [type, value]));
  return `${p.hour}:${p.minute}`;
}

export function amsterdamDateStr(isoStr) {
  return new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Amsterdam' }).format(new Date(isoStr));
}

// Onderdeel 4 (2026-07-26): tegenhanger van `afspraakMoment` in de app
// (src/utils/helpers.js) — twee plekken bijwerken, geen gedeeld package.
// Een PT-aanvraag heeft tot drie momenten: requested_at (gevraagd),
// reschedule_proposed_at (tegenvoorstel) en group_lessons.starts_at van de
// gematerialiseerde les (definitief). De cliëntschermen toonden altijd
// requested_at, ook nadat een alternatief was geaccepteerd.
export function afspraakMoment(aanvraag) {
  if (aanvraag?.lesson?.starts_at) return aanvraag.lesson.starts_at;
  if (aanvraag?.status === 'accepted' && aanvraag?.reschedule_proposed_at) {
    return aanvraag.reschedule_proposed_at;
  }
  return aanvraag?.requested_at || null;
}

export function afspraakIsVerplaatst(aanvraag) {
  const moment = afspraakMoment(aanvraag);
  if (!moment || !aanvraag?.requested_at) return false;
  return new Date(moment).getTime() !== new Date(aanvraag.requested_at).getTime();
}

export function firstOccurrenceDate(startDateStr, targetWeekday) {
  const startUTCNoon = new Date(startDateStr + 'T12:00:00Z');
  const startDayOfWeek = startUTCNoon.getUTCDay();
  const diff = (targetWeekday - startDayOfWeek + 7) % 7;
  return new Date(startUTCNoon.getTime() + diff * 86400000);
}
